<template>
  <v-layout align-center wrap style="min-height: 76px;">
    <v-flex xs2>
      <h3 class="subheading grey--text text--darken-2">業種（任意）</h3>
    </v-flex>
    <v-flex xs10>
      <span v-if="disabled">{{ categoryName }}</span>
      <v-select
        v-else
        v-model="selectValue"
        :items="items"
        :loading="loading"
        item-value="id"
        item-text="name"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    categoryName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchKeyword: '',
      selectedItemName: this.defaultName,
      loading: false,
    }
  },
  computed: {
    ...mapState({
      categoryList: state => state.master.categoryList,
    }),
    items() {
      return this.categoryList
    },
    selectValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {
    this.getList('')
  },
  methods: {
    async getList(keyword) {
      this.loading = true
      this.$store.dispatch('master/CLEAR_CATEGORY_LIST')
      try {
        await this.$store.dispatch('master/GET_CATEGORY_LIST', {
          name: keyword,
        })
      } catch (e) {
        this.loading = false
        const error = new Error('業種の取得に失敗しました。')
        throw error
      }
      this.loading = false
    },
  },
}
</script>
